import { TestListActionTypes } from "../constants/TestListActionTypes";

const TestListState = {
    results: []
}


export const TestListReducer = (state = TestListState, { type, payload }) => {
    switch (type) {
        case TestListActionTypes.GET_TESTS:
            var updatedState = {
                results: payload.results
            }
            return updatedState;
        default:
            return state;
    }
}